import { http } from './http'
import { Days } from '../../common/models'

export const getFestivalDays = (festivalEditionId: string) =>
  http.get<Days[]>(`/operations/festival-edition/${festivalEditionId}/days`)

export const updateFestivalDays = (festivalEditionId: string, data: Days[]) =>
  http.put<Days[]>(
    `/operations/festival-edition/${festivalEditionId}/days`,
    data,
  )

export const deleteFestivalDays = (festivalEditionId: string, id: string) =>
  http.delete(`/operations/festival-edition/${festivalEditionId}/days/${id}`)
